.icon {
  flex: none;
  inline-size: var(--icon-sm);
  block-size: var(--icon-sm);
  fill: none;
  stroke: currentcolor;
  stroke-width: 1.75;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.icon[data-size="md"] {
  inline-size: var(--icon-md);
  block-size: var(--icon-md);
}

.icon[data-size="lg"] {
  inline-size: var(--icon-lg);
  block-size: var(--icon-lg);
  stroke-width: 1.5;
}

.solid {
  fill: currentcolor;
  stroke: none;
}
